import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 120px;
  justify-content: space-between;
  align-items: center;
`;

export default Container;
